import React from "react";

export default function MyTooltip({ title = "", content = "" }) {
	return (
		<div className="mytooltip">
			{title}&nbsp;
			<i className="dripicons-information mytooltip-target"></i>
			<div className="tooltiptext">{content}</div>
		</div>
	);
}
